<form class="billing-address-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div class="items">
    <label [for]="'ba-country-' + uid">{{ 'customerCards.country' | translate }}*</label>
    <input [id]="'ba-country-' + uid" type="text" formControlName="country" [appCountrySelect]="countries">
    @if (showError('country')) {
      <small class="form-error-msg">{{ 'customerCards.requiredField' | translate }}</small>
    }
  </div>

  <div class="items">
    <label [for]="'ba-address-' + uid">{{ 'customerCards.address' | translate }}*</label>
    <input [id]="'ba-address-' + uid" type="text" formControlName="address" [appAddressAutocomplete]="true"
      [maxLength]="textMaxLength" autocomplete="street-address">
    @if (showError('address')) {
      <small class="form-error-msg">{{ 'customerCards.requiredField' | translate }}</small>
    }
  </div>

  <div class="items">
    <label [for]="'ba-state-' + uid">{{ 'customerCards.state' | translate }}*</label>
    <input [id]="'ba-state-' + uid" type="text" formControlName="state" [maxLength]="textMaxLength">
    @if (showError('state')) {
      <small class="form-error-msg">{{ 'customerCards.requiredField' | translate }}</small>
    }
  </div>

  <div class="items">
    <label [for]="'ba-city-' + uid">{{ 'customerCards.city' | translate }}*</label>
    <input [id]="'ba-city-' + uid" type="text" formControlName="city" [maxLength]="textMaxLength">
    @if (showError('city')) {
      <small class="form-error-msg">{{ 'customerCards.requiredField' | translate }}</small>
    }
  </div>

  <div class="items">
    <label [for]="'ba-zip-' + uid">{{ 'customerCards.zipCode' | translate }}@if (isZipRequired) {*}</label>
    <input [id]="'ba-zip-' + uid" type="text" formControlName="zipCode" [maxLength]="zipMaxLength">
    @if (showError('zipCode')) {
      <small class="form-error-msg">
        @if (form.controls.zipCode.hasError('required')) {
          {{ 'customerCards.zipRequired' | translate }}
        } @else {
          {{ zipInvalidMessageKey | translate }}
        }
      </small>
    }
  </div>

  <div class="form-actions">
    <button type="button" class="back-btn" [disabled]="submitting" (click)="onCancel()">{{ 'customerCards.cancel' | translate }}</button>
    <button type="submit" class="continue-btn" [disabled]="submitting">{{ 'customerCards.saveAddress' | translate }}</button>
  </div>
</form>
